/**
 * @file PlanDetailReport.js
 * @description CSV report export configuration and trigger for plan detail report data.
 */

import { planDetailReport } from '../../services/benefitPlanService';
import {
    createCsvReportDefinition,
    exportCsvReport,
} from '../../utils/reporting/csvReportExporter';

const planDetailReportHeaders = [
    'Client Code', 'Plan Detail Code', 'Plan Detail Name', 'Override Name', 'Plan Name',
    'Plan Code', 'Plan Type', 'Plan Year Code', 'In Network Value', 'Out Network Value',
];

function mapPlanDetailRow(planDetail) {
    return {
        clientCode: planDetail.clientCode,
        planDetailCode: planDetail.planDetailCode,
        planDetailName: planDetail.planDetailName,
        overrideName: planDetail.overrideName,
        planName: planDetail.planName,
        planCode: planDetail.planCode,
        planType: planDetail.planType,
        planYearCode: planDetail.planYearCode,
        inNetworkValue: planDetail.inNetworkValue,
        outOfNetworkValue: planDetail.outOfNetworkValue,
    };
}

async function getPlanDetailData() {
    return planDetailReport([], [], []);
}

const planDetailReportDefinition = createCsvReportDefinition({
    headers: planDetailReportHeaders,
    filenamePrefix: 'planDetailReport',
    getData: getPlanDetailData,
    mapRow: mapPlanDetailRow,
});

export async function downloadReport() {
    await exportCsvReport(planDetailReportDefinition);
}